import { ButtonActionTypeEnum } from 'common/enums/ButtonActionTypeEnum'
import LibraryElementEnum from '../../client/enums/LibraryElementEnum'
import EntityTypeEnum from '../enums/entityTypeEnum'
import { redirectionTypes } from './buttonTypes'
import { buttonActionsTypes } from './settings'
import structureTypes from './structureTypes'
import toolBoxTypes from './toolBoxTypes'

const createChildlessStructure = (type, styles, options) => ({
  [type]: {
    ...(styles ? { styles } : {}),
    ...(options ? { options } : {}),
  },
})

const layout12Structure = {
  [EntityTypeEnum.Row]: {
    children: [createChildlessStructure(EntityTypeEnum.Column)],
  },
}

const mapToolBoxToStructure = {
  [toolBoxTypes.TOOLBOX_AUDIO]: createChildlessStructure(EntityTypeEnum.Audio),
  [toolBoxTypes.TOOLBOX_IMAGE]: createChildlessStructure(EntityTypeEnum.Image),
  [toolBoxTypes.TOOLBOX_FORM_INPUT]: createChildlessStructure(
    structureTypes.FORM_INPUT,
  ),
  [LibraryElementEnum.LibraryWebinarSessionDateTime]: createChildlessStructure(
    EntityTypeEnum.WebinarSessionDateTime,
  ),
  [toolBoxTypes.TOOLBOX_BUTTON]: createChildlessStructure(
    structureTypes.BUTTON,
  ),
  [toolBoxTypes.TOOLBOX_BLOG_BUTTON]: {
    [structureTypes.BUTTON]: {
      options: {
        action: buttonActionsTypes.sendForm,
        redirectionType: redirectionTypes.customUrl,
      },
    },
  },
  [toolBoxTypes.TOOLBOX_OPEN_URL_BUTTON]: createChildlessStructure(
    structureTypes.BUTTON,
    {},
    {
      action: buttonActionsTypes.openUrl,
    },
  ),
  [LibraryElementEnum.LibrarySection]: {
    [EntityTypeEnum.Section]: {
      children: [layout12Structure],
    },
  },
  [toolBoxTypes.TOOLBOX_CONTENT_BOX]: {
    [structureTypes.CONTENT_BOX]: {
      children: [layout12Structure],
    },
  },
  [toolBoxTypes.TOOLBOX_PAYMENT_METHOD]: createChildlessStructure(
    structureTypes.PAYMENT_METHOD,
  ),
  [toolBoxTypes.TOOLBOX_CUSTOMER_TYPE]: createChildlessStructure(
    structureTypes.CUSTOMER_TYPE,
  ),
  [toolBoxTypes.TOOLBOX_PAYMENT_BUTTON]: createChildlessStructure(
    structureTypes.PAYMENT_BUTTON,
  ),
  [LibraryElementEnum.LibraryPaymentButton]: createChildlessStructure(
    LibraryElementEnum.LibraryPaymentButton,
  ),
  [LibraryElementEnum.LibraryButton]: createChildlessStructure(
    EntityTypeEnum.Button,
  ),
  [LibraryElementEnum.LibraryWebsiteButton]: createChildlessStructure(
    EntityTypeEnum.WebsiteButton,
  ),
  [LibraryElementEnum.LibraryOpenUrlButton]: {
    [EntityTypeEnum.Button]: {
      action: ButtonActionTypeEnum.OpenUrl,
    },
  },
  [toolBoxTypes.TOOLBOX_SALES_PHYSICAL_PRODUCT]: {
    [EntityTypeEnum.Row]: {
      children: [
        {
          [EntityTypeEnum.Column]: {
            children: [
              createChildlessStructure(structureTypes.PHYSICAL_PRODUCT),
            ],
          },
        },
      ],
    },
  },
  [toolBoxTypes.TOOLBOX_PAYMENT_PHYSICAL_PRODUCT]: createChildlessStructure(
    structureTypes.PHYSICAL_PRODUCT,
  ),
  [toolBoxTypes.TOOLBOX_START_TIMER]: createChildlessStructure(
    structureTypes.START_TIMER,
  ),
  [toolBoxTypes.TOOLBOX_AGREEMENT]: createChildlessStructure(
    structureTypes.AGREEMENT,
  ),
  [LibraryElementEnum.LibraryCoupon]: createChildlessStructure(
    LibraryElementEnum.LibraryCoupon,
  ),
  [toolBoxTypes.TOOLBOX_LANGUAGE_SWITCHER]: createChildlessStructure(
    structureTypes.LANGUAGE_SWITCHER,
  ),
}

export const getContainerEntityStructure = type => {
  switch (type) {
    case structureTypes.BLOG_PAGE_BODY:
    case structureTypes.BLOG_POST_BODY:
    case structureTypes.BLOG_POST_LAYOUT_BODY:
    case EntityTypeEnum.BlogPostBody:
    case EntityTypeEnum.BlogPageBody:
    case EntityTypeEnum.BlogPostLayoutBody:
    case structureTypes.BODY:
    case EntityTypeEnum.Body:
      return [EntityTypeEnum.Section, EntityTypeEnum.Row, EntityTypeEnum.Column]
    case EntityTypeEnum.Section:
      return [EntityTypeEnum.Row, EntityTypeEnum.Column]
    case EntityTypeEnum.Row:
      return [EntityTypeEnum.Column]
    default:
      return []
  }
}

export const getMovableEntityStructure = type => {
  switch (type) {
    case EntityTypeEnum.Section:
    case structureTypes.SECTION:
      return []
    case EntityTypeEnum.Row:
    case structureTypes.ROW:
      return [EntityTypeEnum.Section, structureTypes.SECTION]
    default:
      return [
        EntityTypeEnum.Section,
        structureTypes.SECTION,
        EntityTypeEnum.Row,
        structureTypes.ROW,
        EntityTypeEnum.Column,
        structureTypes.COLUMN,
      ]
  }
}

export default mapToolBoxToStructure
